<template>
	<div class="sign_wrap">
		<el-button v-if="!isAgreement" class="start_btn" type="primary" @click="agreement()">开始入驻</el-button>
		<h3 class="f666 tc">{{ title }}</h3>
		<div class="intro">
			<p>一.入驻流程</p>
			<p>入驻申请→初审→编辑线上合同→复审→缴纳保证金→提交纸质材料→开通后台账号；</p>
			<p>注：每一个环节的状态，系统都会邮件或短信告知商家，商家也可以登入注册账号进行查询。</p>
		</div>
		<div class="up_info mt20">
			<p>二.入驻须知</p>
			<p>(1) 商家入驻的品类如果涉及到多个部门，系统仅允许“先”入驻一个部门负责的品类，待入驻成功后方可入驻其他品类；</p>
			<p>(2) 商家申请主营品牌有两种方式：第一种，选择大V店品牌库已有的品牌；第二种，手动输入大V店品牌库还未录入的品牌信息。商家需优先采用第一种方式，如果品牌库搜索不到，再采用第二种方式；</p>
			<p>(3) 非图书品类的每一个品牌均需选择要入驻的品类，未选择入驻的品类，后期创建商品信息则无法创建成功；</p>
			<p>(4) 入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销；</p>
			<p>(5) 商家入驻多个品类，只需缴纳一份保证金，保证金取多个品类中最高的。</p>
		</div>
		<div v-if="isAgreement">
			<el-checkbox class="mt20" v-model="checked" @change="hangle">我同意大V店《供应商入驻协议》</el-checkbox>
			<div class="tc">
				<router-link :to="checked ? '/edit_info_basic' : '#'">
					<el-button type="primary" :disabled="!checked">下一步</el-button>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				applyStatus: null,		// 申请状态,Integer,0:未申请,1:申请中
				title: "大V店入驻事项",
				checked: false,					// 是否同意协议
				isAgreement: false      // 是否入驻协议
			}
		},
		methods: {
			agreement () {
				var _this = this;
				$.get({
					url: '/suppliers/supplierSettled/findSupplierApplyStatus',
					success: function (result) {
						if (!result.code) {
//							if (result.data.applyStatus == 0) {
//								_this.title = "供应商入驻协议"
//								_this.isAgreement = true
//								window.sessionStorage["supplierApplyId"] = 0;
//							} else
							if (result.data.applyStatus == 0 || result.data.applyStatus == 1) {
								_this.$router.push({
									path:"/edit_info_basic?" + "supplierApplyId=" + (result.data.supplierApplyId ? result.data.supplierApplyId : 0)
								});
//								window.sessionStorage["supplierApplyId"] = result.data.supplierApplyId;
							} else if (result.data.applyStatus == 2) {
								_this.$router.push({
									path:'/edit_info_basic'
								})
//								window.sessionStorage["supplierApplyId"] = result.data.supplierApplyId;
							} else  {
								_this.$router.push({
									path:'/supplier_skan'
								})
//								window.sessionStorage["supplierApplyId"] = result.data.supplierApplyId;
							}

						} else {
							_this.$message({
								message: result.msg,
								type: 'error'
							});
						}
					}
				});


			},
			hangle () {
				console.log(this.checked)
			}
		}
	}
</script>

<style type="text/css" lang="less" scoped>
	.sign_wrap {
		width: 1042px;
	  height: 750px;
	  margin: 80px auto;
	  border: 1px solid #eee;
	  position: relative;
	  padding: 70px 50px;
	}
	.start_btn {
		position: absolute;
		top: -52px;
		right: 0;
	}
	.intro,
	.up_info {
		font-size: 14px;
		color: #333;
		p {
			line-height: 30px;
		}
	}
</style>


// WEBPACK FOOTER //
// matters.vue?7a014265